import getLocal from '@/app/utils/getLocal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import { getProductData } from '@elem/utils/getProductData';
import { useEffect } from 'react';
import { useProductDispatch, useProductStore } from '../../ProductProvider';

const generalKey = 'product_ps_river_river_705';

export default function GetProductData() {
    const { gloproductlist } = useGlobal();
    const { productPageData } = useProductStore();
    const dispatch = useProductDispatch();
    const { locale } = getLocal();
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });

    useEffect(() => {
        const getProductDataHandle = async () => {
            const productPageData = await getProductData(productMsg, locale, productMsg?.spuId || productMsg?.sourceId);
            console.log('productPageData', productPageData);
            dispatch({
                type: 'changeProductPageData',
                payload: productPageData,
            });
        };
        const productCatagory = productPageData?.productCatagory;
        if (!productCatagory) {
            getProductDataHandle();
        }
    }, []);
    return null;
}
